module.exports = __webpack_public_path__ + "static/img/sixLast.42368ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sixLast.png
// module id = 37Am
// module chunks = 1